import { EPaginationActionTypes } from '../../actions/pagination';
import { EPromosActionTypes } from '../../actions/promos';
import { mapTotalCountText } from '../../mappers';

import { TReduxActions } from '../../types/redux';
import { TTotalCount } from '../../types/totalCount';

const defaultState: TTotalCount = null;

export function totalCountReducer(state: TTotalCount = defaultState, action: TReduxActions) {
  if (action.type === EPromosActionTypes.Success || action.type === EPaginationActionTypes.Success) {
    return mapTotalCountText(action.payload);
  }

  return state;
}
